<template>
	<div>

		<v-data-table
			:headers="encabezado"
			:items="fuente.listado"
			item-key="identificador"
			class="elevation-1 mb-16"
			:items-per-page="10000"
			:loading="fuente.listando"
			hide-default-footer
		>
			<template v-slot:item.tipo="{ item }">
				{{ item.tipo === 'natural' ? 'Natural' : item.tipo === 'jurídica' ? 'Jurídica' : item.tipo }}
			</template>
			<template v-slot:item.nombre="{ item }">
				<div v-if="item.tipo === 'natural' && item.natural">
					{{ `${item.natural.nombres} ${item.natural.apellidos}` }}
				</div>
				<div v-if="item.tipo === 'jurídica' && item.jurídica">
					{{ item.jurídica.nombreLegal }}
				</div>
				<div v-if="!item.habilitada" class="red--text font-italic caption">
					Inhabilitada
				</div>
			</template>
			<template v-slot:item.identificación="{ item }">
				<div v-if="item[item.tipo] && item[item.tipo].identificaciones && item[item.tipo].identificaciones.locales">
					<div v-for="(iden, i) in item[item.tipo].identificaciones.locales" :key="`id-lcl-${i}`">
						{{ iden.valor }}
					</div>
				</div>
			</template>
			<template v-slot:item.acciones="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon v-on="on" v-bind="attrs" @click="abrirEdición(item)">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span>Editar persona</span>
				</v-tooltip>
			</template>
		</v-data-table>

		<v-dialog
			v-model="diálogoPersona"
      max-width="900"
			persistent
		>
			<persona
				:datos="personaSeleccionada"
				@guardar="diálogoPersona = false"
				@cancelar="diálogoPersona = false"
			></persona>
		</v-dialog>

		<v-btn
			fixed
			dark
			fab
			bottom
			right
			color="pink"
			@click.stop="diálogoPersona = true"
		>
			<v-icon>mdi-plus</v-icon>
		</v-btn>

	</div>
</template>

<script>
import { personas } from '@/../../cliente_comun/fuentes'
import { moneda } from '@/../../cliente_comun/utilidades'
import Persona from '@/components/persona.vue'

export default {
	name: 'Personas',
  data: () => ({
		fuente: personas,
		encabezado: [
			{ text: 'Tipo', value: 'tipo', sortable: false },
			{ text: 'Nombre', value: 'nombre', sortable: false },
			{ text: 'Identificación', value: 'identificación', sortable: false },
			{ text: '', value: 'acciones', align: 'end', filterable: false, sortable: false },
		],
		personaSeleccionada: null,
		diálogoPersona: false,
		datosSelección: null
	}),
	components: {
		Persona
	},
	mounted: function() {
		this.fuente.inicializar()
	},
	methods: {
		moneda,
		cerrarDiálogo: function() {
			this.personaSeleccionada = null
			this.diálogoPersona = false
		},
		abrirEdición: function(el) {
			this.diálogoPersona = true
			this.$nextTick(() => {
				this.personaSeleccionada = el
			})
		},
	}
}

</script>